import useSWR from 'swr';
import { createContext, useContext, useState } from 'react';
import { fetchIsStaff } from './data';
import { isBrowser } from '../../utils/isBrowser';

interface UserSettingsContext {
  isStaff: boolean;
  ctaSubscribeEnabled: boolean;
  setCtaSubscribeEnabled: Function;
  ctaSignupEnabled: boolean;
  setCtaSignupEnabled: Function;
}

const isSubscribePopupDisabled = (): boolean =>
  !isBrowser() || window.sessionStorage.disableBlogSubscribePopup === 'true';

const isSignupPopupDisabled = (): boolean =>
  !isBrowser() || window.sessionStorage.disableBlogSignupPopup === 'true';

const disableSignupPopup = () =>
  (window.sessionStorage.disableBlogSignupPopup = 'true');

export const disableSubscribePopup = () =>
  (window.sessionStorage.disableBlogSubscribePopup = 'true');

export const UserSettingsContext = createContext<
  UserSettingsContext | undefined
>(undefined);

export const useUserSettingsContext = () => useContext(UserSettingsContext);

type Props = {
  children: React.ReactNode;
};

export function UserProvider({ children }: Props) {
  const { data: isStaff } = useSWR('currentUser', fetchIsStaff, {
    revalidateOnFocus: false,
  });

  const [ctaSubscribeEnabled, setCtaSubscribeEnabled] = useState(
    !isSubscribePopupDisabled(),
  );
  const [ctaSignupEnabled, setCtaSignupEnabled] = useState(
    !isSignupPopupDisabled(),
  );

  const context = {
    isStaff: !!isStaff,
    ctaSubscribeEnabled,
    setCtaSubscribeEnabled: (isEnabled: boolean) => {
      if (!isEnabled) {
        disableSubscribePopup();
      }
      setCtaSubscribeEnabled(isEnabled);
    },
    ctaSignupEnabled,
    setCtaSignupEnabled: (isEnabled: boolean) => {
      if (!isEnabled) {
        disableSignupPopup();
      }
      setCtaSignupEnabled(isEnabled);
    },
  };

  return (
    <UserSettingsContext.Provider value={context}>
      {children}
    </UserSettingsContext.Provider>
  );
}
